
/***********************************
 * When on error it shows an internal message snack bar, it means there is a code error in the api, activate console.lo on the error catch
********************************/

import axios from 'axios';
import { openSnackbar } from 'api/snackbar';




const axiosProduction = axios.create({ 
  baseURL: process.env.REACT_APP_PRODUCTION === 'TRUE' ? process.env.REACT_APP_API_URL_PRODUCTION : process.env.REACT_APP_API_URL_DEVELOPMENT,
  withCredentials: false,
  headers: { 'Content-Type': 'application/json' }
});

const axiosProductionMultiPart = axios.create({ 
  baseURL: process.env.REACT_APP_PRODUCTION === 'TRUE' ? process.env.REACT_APP_API_URL_PRODUCTION : process.env.REACT_APP_API_URL_DEVELOPMENT,
  withCredentials: false,
  headers: {'Content-Type': 'multipart/form-data' }
});










// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosProduction.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosProduction.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && !window.location.href.includes('/login')) {
      window.location = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosProduction;



axiosProductionMultiPart.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && !window.location.href.includes('/login')) {
      window.location = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);








//--------------------------------------------------------------------------
export const fetcherProduction = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosProduction.get(url, { ...config });

  return res.data;
};

export const fetcherPostProduction = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosProduction.post(url, { ...config });

  return res.data;
};




//--------------------------------------------------------------------------
export const PostAPI= async ({url, data, showSuccessNotification, showErrorNotification, onSuccess, onError}) => 
{
  console.log("PostAPI",url);
  axiosProduction.post(url, data)
    .then((response) => {
      //console.log(response);
      
      if(showSuccessNotification)
      {
        openSnackbar({
          open: true,
          message: response.data.message?response.data.message:"",
          alert: {
            color: 'success',
            severity: 'success'
          }
        });
      }

      if(onSuccess)
      {
        onSuccess(response.data, data);
      }

      return;
    })
    .catch((error) => {
      console.log(error);
      var msg = "Error no  identificado";
      if (error.response) {
        msg = "Error en respuesta de servidor: "+error.response;
      } else if (error.request) {
        msg = "Error en la conexión de internet";
      } else {
        msg = error?.message
      }

      if(showErrorNotification)
      {
        openSnackbar({
          open: true,
          message: msg,
          alert: {
            color: 'error',
            severity: 'error'
          }
        });
      }

      if(onError)
      {
        onError(error);
      }
      
      return;
    });
}





//--------------------------------------------------------------------------
export const PostAPIMultipart= async ({url, data, showSuccessNotification, showErrorNotification, onSuccess, onError}) => 
{
  axiosProductionMultiPart.post(url, data)
    .then((response) => {
      //console.log(response);

      if(showSuccessNotification)
      {
        openSnackbar({
          open: true,
          message: response.data.message?response.data.message:"",
          alert: {
            color: 'success',
            severity: 'success'
          }
        });
      }

      if(onSuccess)
      {
        onSuccess(response.data);
      }

      return;
    })
    .catch((error) => {
      console.log(error);
      var msg = "Error no  identificado";
      if (error.response) {
        msg = "Error en respuesta de servidor: "+error.response;
      } else if (error.request) {
        msg = "Error en la conexión de internet";
      } else {
        msg = error?.message
      }

      if(showErrorNotification)
      {
        openSnackbar({
          open: true,
          message: msg,
          alert: {
            color: 'error',
            severity: 'error'
          }
        });
      }

      if(onError)
      {
        onError(error);
      }
      
      return;
    });
}

